import { render, staticRenderFns } from "./MeetGreetChatEnded.vue?vue&type=template&id=3070d0a2&"
import script from "./MeetGreetChatEnded.vue?vue&type=script&lang=js&"
export * from "./MeetGreetChatEnded.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports